import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
// import Markdown from 'preact-markdown';

import util from '../../lib/util';
import markdown from '../../lib/markdown';

@observer
class Textarea extends Component {
    render() {
        const {
            handleKeydown = () => {},
            onInput = () => {},
            id,
            isValid,
            name,
            placeholder = '',
            readonly,
            required,
            value,
            rows,
            help,
            removeHtml,
        } = this.props;

        return (
            <div class='row'>
                <div class='col-6'>
                    <textarea class={`form-control ${isValid ? 'is-valid' : ''}`}
                        id={`input${name}-${id}`}
                        name={name}
                        rows={rows}
                        placeholder={placeholder}
                        readonly={readonly}
                        required={required}
                        value={removeHtml ? util.removeHtml(value) : value}
                        onInput={onInput}
                        onKeyDown={handleKeydown}
                    />
                    {isValid ? <div class='valid-feedback' style='display: block;'>
                        Looks good. Saving...
                    </div> : <small id={`${name}Help`} class='form-text text-muted'>
                        <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                        <small class='float-right'>"{name}"</small>
                        {help}
                    </small>}
                </div>
                <div class='col-6'>
                    <div class='lead' id='ingressDisplay' dangerouslySetInnerHTML={{
                        __html: markdown.render(value),
                    }} />
                </div>
            </div>
        );
    }
}

export default Textarea;



// WEBPACK FOOTER //
// ./components/form/textarea.js